import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import SearchFormContainer from "Components/atoms/containers/search-form-container"
import ToFromInput from "Components/molecule/inputs/to-from-input"
import { SelectOption } from "Components/molecule/inputs/select-input"
import { IConsultingRevenueVsBudgetQuery } from "models/consulting-revenue-budget"
import useEnterSearch from "hooks/useEnterSearch"

interface SearchConsultingRevenueVsBudgetFormProps {
    query: IConsultingRevenueVsBudgetQuery
    fiscalPeriodOptions: SelectOption[]
    isSearching: boolean
    handleChangeQuery: (key: string, value: any) => void
    handleSearch: () => void
    handleClearSearch: () => void
}

const SearchConsultingRevenueVsBudgetForm = ({
    query,
    fiscalPeriodOptions,
    isSearching,
    handleChangeQuery,
    handleSearch,
    handleClearSearch,
}: SearchConsultingRevenueVsBudgetFormProps) => {
    const { selectProps } = useEnterSearch(handleSearch)

    return (
        <SearchFormContainer
            inputs={
                <ToFromInput
                    fromFiscalPeriod={query.fromPeriod!}
                    toFiscalPeriod={query.toPeriod!}
                    handleChangeFrom={(val) => handleChangeQuery('fromPeriod', val)}
                    handleChangeTo={(val) => handleChangeQuery('toPeriod', val)}
                    fiscalPeriodOptions={fiscalPeriodOptions}
                    containerStyle={{ minWidth: '100%' }}
                    {...selectProps}
                />
            }
            clearSearchButton={
                <>
                    <PrimaryButton
                        style={{ minWidth: '150px' }}
                        disabled={isSearching}
                        onClick={handleSearch}
                    >
                        {isSearching ? 'Searching...' : 'Search'}
                    </PrimaryButton>
                    <SecondaryButton
                        style={{ minWidth: '100px' }}
                        disabled={isSearching}
                        onClick={handleClearSearch}
                    >
                        Clear Search
                    </SecondaryButton>
                </>
            }
        />
    )
}

export default SearchConsultingRevenueVsBudgetForm
